import cloneDeep from 'lodash/cloneDeep';
import replace from 'lodash/replace';
import trim from 'lodash/trim';
import styled, { css } from 'styled-components/macro';
import { colorCoreBlack500, colorCoreWhite1000 } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { elevationBottomLvl2 } from '@yme/tokens/elevations';
import { INDENT } from '@yme/tokens/sizes';
import { UbuntuFontFamily, lineHeightXS, fontSizeS, fontWeightMedium, } from '@yme/tokens/typography';
import { Z_INDEX } from '@yme/tokens/zindex';
import { CLUSTER_CLASS_NAME } from './constants';
const removeSemicolon = (cssStyles) => {
    const cssCopy = cloneDeep(cssStyles);
    cssCopy[0] = replace(trim(cssStyles[0]), ';', '');
    return cssCopy;
};
const patchedDefaultGoogleMapStyles = css `
  .gm-style-iw.gm-style-iw-c > button {
    visibility: hidden;
  }
  .gm-style .gm-style-iw-c {
    padding: 0;
  }
  .gm-style-iw-d {
    overflow: auto !important;
  }
  .${CLUSTER_CLASS_NAME} {
    width: 40px !important;
    height: 40px !important;
  }
  .${CLUSTER_CLASS_NAME} > img {
    display: none;
  }
  .${CLUSTER_CLASS_NAME} > div {
    box-sizing: border-box;
    width: 40px !important;
    height: 40px !important;
    background-color: ${colorCoreBlack500} !important;
    border: 2px solid ${colorCoreWhite1000} !important;
    border-radius: ${CORNER_RADIUS.circle} !important;
    box-shadow: ${elevationBottomLvl2} !important;
    color: ${colorCoreWhite1000} !important;
    display: flex;
    justify-content: center;
    align-items: center;
    ${removeSemicolon(fontSizeS)} !important;
    ${removeSemicolon(lineHeightXS)} !important;
    ${removeSemicolon(fontWeightMedium)} !important;
    ${removeSemicolon(UbuntuFontFamily)} !important;
  }
`;
const fullscreenWrapperStyles = css `
  position: fixed;
  z-index: ${Z_INDEX.popupLevel2};
  left: 0;
  right: 0;
  bottom: 0;
  height: 100dvh;
`;
export const WrapperStyled = styled.div `
  ${({ isFullscreen }) => isFullscreen
    ? fullscreenWrapperStyles
    : `
        position: relative;
        min-width: 320px;
        min-height: 320px;
        width: 100%;
        height: 100%;
      `};
  ${({ isHiddenCloseIcon }) => isHiddenCloseIcon &&
    css `
      .gm-style-iw-chr button {
        display: none !important;
        opacity: 0;
      }
    `}

  ${patchedDefaultGoogleMapStyles};
`;
export const mapNodeStyle = {
    width: '100%',
    height: '100%',
};
export const GOOGLE_TERMS_HEIGHT = '15px';
const ControlContainerStyled = styled.div `
  position: absolute;
  right: ${INDENT.xs};
`;
export const TopControlContainerStyled = styled(ControlContainerStyled) `
  top: ${INDENT.xs};
`;
export const BottomControlContainerStyled = styled(ControlContainerStyled) `
  bottom: calc(${INDENT.xs} + ${GOOGLE_TERMS_HEIGHT});
`;
export const ToastWrapperStyled = styled.div `
  position: absolute;
  bottom: ${INDENT.xl};
  left: ${INDENT.xl};
`;
